import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { useAuth } from '../context/AuthContext';
import { Activity, LogOut, User } from 'lucide-react';

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="glass-header sticky top-0 z-50 border-b border-slate-200">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="logo-link">
          <Activity className="h-8 w-8 text-primary" />
          <span className="text-2xl font-manrope font-bold text-slate-900">Booking Vedamrita</span>
        </Link>

        <div className="flex items-center gap-4">
          {user ? (
            <>
              <Link to="/dashboard">
                <Button variant="ghost" data-testid="dashboard-link">
                  <User className="h-4 w-4 mr-2" />
                  {user.full_name}
                </Button>
              </Link>
              <Button
                variant="outline"
                onClick={handleLogout}
                data-testid="logout-button"
              >
                <LogOut className="h-4 w-4 mr-2" />
                Logout
              </Button>
            </>
          ) : (
            <>
              <Link to="/login">
                <Button variant="ghost" data-testid="login-link">Login</Button>
              </Link>
              <Link to="/register">
                <Button data-testid="register-link">Get Started</Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};